
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachDashboardRootPostsFormRemove} from "@/models/app/coach/dashboard/root/posts/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "post",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachDashboardRootPostsFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  post: AppCoachDashboardRootPostsFormRemove = new AppCoachDashboardRootPostsFormRemove();

  formData: AppCoachDashboardRootPostsFormRemove = new AppCoachDashboardRootPostsFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/post/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getPosts');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.post;
  }

  resetFormData(): void {
    this.formData = new AppCoachDashboardRootPostsFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
